<pf-listview [title]="'email.title' | translate" [items]="filteredEmailTemplateList()"
    [addRouterLink]="'/addnewsletter'" [useDragDrop]="false" [hasSearchSection]="true">
    <ng-template #headerTemplate>
        <div class="mat-radio-container"></div>
        <mat-radio-group [ngModel]="filterType()">
            <mat-radio-button class="toggle-button" [value]="ALL" (click)="filterAll()">{{'email.all'
                | translate}}</mat-radio-button>
            <mat-radio-button class="toggle-button" [value]="NEWSLETTER" (click)="filterNewsLetter()">
                {{'email.newsletter' | translate}}
            </mat-radio-button>
            <mat-radio-button class="toggle-button" [value]="SIMPLE" (click)="filterSimpleEmails()"> {{'email.automated'
                | translate}}
            </mat-radio-button>
        </mat-radio-group>
    </ng-template>
    <ng-template #itemTemplate let-item let-i="index">
        <div class="email-row-layout" [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }">
            <div class="name-link" (click)="routeToEditEmailTemplate(item)" style="cursor: pointer;">
                {{ getTranslatedName(item) }}
            </div>

            <div class="status-block">
                <div class="data-container">
                    @if (!item.newsletter) {
                    <mat-icon class="email-icon">email</mat-icon>
                    }

                    @if (item.newsletter) {
                    @if (item.currentEmailQueueCount === 0) {
                    @if (item.alreadySent) {
                    <mat-icon class="email-icon" [ngStyle]="{ cursor: 'pointer' }" (click)="rescheduleNewsLetter(item)">
                        replay
                    </mat-icon>
                    }
                    @if (!item.alreadySent) {
                    <mat-icon class="email-icon" [ngStyle]="{ cursor: 'pointer' }"
                        (click)="scheduleNewsLetter(item, false)">
                        send
                    </mat-icon>
                    }
                    }

                    @if (item.currentEmailQueueCount > 0) {
                    <div class="progress-wrapper" style="min-width: 120px;">
                        <mat-progress-bar mode="indeterminate" [color]="progressColor" />
                        <small>{{'email.theRest' | translate}}: {{ item.currentEmailQueueCount }}</small>
                    </div>
                    }
                    }
                </div>
            </div>

            <div class="delete">
                @if (!item.alreadySent) {
                <mat-icon (click)="openDeleteDialog(item.templateName)" style="cursor: pointer;">
                    delete_forever
                </mat-icon>
                }
            </div>

        </div>
    </ng-template>
</pf-listview>